/* eslint-disable */
import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import {removeCookie} from '../Cookie/cookie'
import {loadBrand} from '../BaseComponent/configTheme'

class AdminMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,

      openAdminMenu: false,
      firstname: '',
      lastname: '',
      openUserPanel: false,
      isOpen: false,
      openReports: false,
      openOrders: false,
      permissionArr: [],
      showCreatePreRecord: true
    }
  }

  toggleCollapse() {
    this.setState({isOpen: !this.state.isOpen})
  }

  componentDidMount() {
    $(function() {
      $('#menu > li > a').on('click', function(event) {
        $(this)
          .siblings('ul.subMenu')
          .slideToggle()
        $(this)
          .siblings('span.caret')
          .toggleClass('upCaret')
        $(this)
          .parent()
          .siblings()
          .find('.subMenu')
          .slideUp()
        $(this)
          .parent()
          .siblings()
          .find('.caret')
          .removeClass('upCaret')
      })

      $('.subLink').on('click', function(event) {
        $(this)
          .siblings('ul.SubSubMenu')
          .slideToggle()
        $(this)
          .siblings('span.caret')
          .toggleClass('upCaret')
        $(this)
          .parent()
          .siblings()
          .find('.caret')
          .removeClass('upCaret')
        $(this)
          .parent()
          .siblings()
          .find('.SubSubMenu')
          .slideUp()
      })

      $('.secondsubLink').on('click', function(event) {
        $(this)
          .siblings('ul.SubSubSubMenu')
          .slideToggle()
        $(this)
          .siblings('span.caret')
          .toggleClass('upCaret')
        $(this)
          .parent()
          .siblings()
          .find('.caret')
          .removeClass('upCaret')
        $(this)
          .parent()
          .siblings()
          .find('.SubSubSubMenu')
          .slideUp()
      })

      $('.userIcon').click(function() {
        $('.profileMenu,.triangle-down').show()
      })

      $('.profileMenu').click(function(e) {
        if ($(e.target).is(':not(.profileItems *)') == true) {
          $('.profileMenu,.triangle-down').hide()
        }
      })
    })

    document.body.addEventListener('click', this.close)
  }

  componentDidUpdate(prevProps) {
    /*for close menuBar*/
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (this.props.location.pathname === '/addPreRecord') {
        this.setState({
          showCreatePreRecord: false
        })
      } else {
        this.setState({
          showCreatePreRecord: true
        })
      }
      if (this.state.openAdminMenu) {
        this.onRouteChanged()
        return false
      }
    }
  }

  onRouteChanged() {
    this.setState({
      openAdminMenu: false
    })
  }

  close = (e) => {
    if (this.dashboardMenu && !this.dashboardMenu.contains(e.target)) {
      if (this.state.openAdminMenu) {
        this.setState({
          openAdminMenu: !this.state.openAdminMenu
        })
      }
    }
  }

  logOut() {
    // sessionStorage.removeItem('accessToken');
    // sessionStorage.removeItem('refreshToken');
    // cookie.remove('accessToken');
    // cookie.remove('BaccessToken');
    // cookie.remove('refreshToken');
    // cookie.remove('BrefreshToken');
    sessionStorage.clear()
    removeCookie()
    if (cookie.load('accessToken') === undefined) {
      window.location.assign('/')
    } else {
      removeCookie()

      // cookie.remove('accessToken');
      // cookie.remove('BaccessToken');
      // cookie.remove('refreshToken');
      // cookie.remove('BrefreshToken');
      window.location.assign('/')
    }
  }

  openAdminMenu() {
    this.setState({
      openAdminMenu: !this.state.openAdminMenu
    })
  }

  back() {
    window.history.back()
  }

  randomNumber = () => {
    return Math.random()
  }

  render() {
    // const permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    // alert('test'+JSON.stringify(permissions))
    const ClassAdminMenu = this.state.openAdminMenu ? 'adminMenu' : 'adminMenu hide'
    let name = cookie.load('name')
    return (
      <div>
        <React.Fragment>
          <div className="header" style={{background: loadBrand().color}}>
            <span className="AdminMenuBtn" onClick={this.openAdminMenu.bind(this)}>
              <img src={require('../../image/barMenu.svg')} alt="" />
            </span>

            <div className="wrapperIframe headerEl">
              <div className="brandImage">
                <Link to={'/dashboard'}>
                  <img src={loadBrand().logo} alt="logo" />
                </Link>
                {/*<span style={{color: '#3a4f19', cursor: 'pointer'}} onClick={this.back.bind(this)}>*/}
                {/*بازگشت*/}
                {/*</span>*/}
              </div>
              <div className="Profile">
                <span className="userIcon" title="پروفایل">
                  <img src={require('../../image/user.svg')} alt="user" />
                </span>
                <span className="backIcon" onClick={this.back.bind(this)} title="برگشت">
                  <img src={require('../../image/back.svg')} alt="back" />
                </span>

                <div className="triangle-down" />
                <div className="profileMenu">
                  <ul className="profileItems">
                    <figure className="accessInfo">
                      <p>{name}</p>
                    </figure>
                    <li>
                      <Link to="/Search">
                        <i className="fas fa-desktop" />
                        پنل اپراتور
                      </Link>
                    </li>
                    <li>
                      <Link to="/Profile">
                        <i className="fas fa-user-edit" />
                        ویرایش پروفایل
                      </Link>
                    </li>
                    <li>
                      <Link to="/Profile">
                        <i className="fas fa-cog" />
                        تغییر کلمه عبور
                      </Link>
                    </li>
                    <li>
                      <button onClick={this.logOut.bind(this)}>
                        <i className="fas fa-power-off" />
                        خروج
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className={ClassAdminMenu} ref={(node) => (this.dashboardMenu = node)}>
            <ul id="menu">
              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>
                <a href="#">توزیع</a>

                <ul className="subMenu">
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      رساننده ها
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/setLeave'}>ثبت مرخصی</Link>
                      </li>
                      <li>
                        <Link to={'/reportLeave'}>گزارش مرخصی ها</Link>
                      </li>

                      <li>
                        <Link to={`/activeDrivers`}>رساننده های فعال</Link>
                      </li>

                      <li>
                        <Link to={`/manage/driver/reportCard`}>کارنامه رساننده ها</Link>
                      </li>

                      <li>
                        <Link to={`/manage/driver/list`}>سرعت رساننده ها</Link>
                      </li>

                      <li>
                        <Link to={`/report/ActivityDrivers`}>گزارش فعالیت رساننده ها</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      تسویه رساننده
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/financial/settlement`}>ایجاد سند تسویه</Link>
                      </li>

                      <li>
                        <Link to={`/report/settlement/drivers`}>گزارش تسویه رساننده ها</Link>
                      </li>

                      <li>
                        <Link to={`/report/settlement/withOutSettleDrivers`}>رساننده های فاقد سند تسویه</Link>
                      </li>

                      <li>
                        <Link to={`/masterReport`}>تسویه خودکار</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link to={`/search`}>پلن های توزیع</Link>
                  </li>

                  <li>
                    <Link to={`/assign/by/opTime`}>تخصیص با فایل optime</Link>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      پارت تحویل های برگشتی
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/returnedPlans/returned`}>مشاهده و تعیین تکلیف</Link>
                      </li>

                      <li>
                        <Link to={`/returnedPlans/report/rejected`}>گزارش مرجوعی ها</Link>
                      </li>

                      <li>
                        <Link to={`/returnedPlans/report/reAssign`}>گزارش تخصیص مجدد ها</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      وضعیت سفارشات
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/orderStatus'}>افزودن وضعیت سفارش</Link>
                      </li>

                      <li>
                        <Link to={'/orderList'}>گزارش سفارشات</Link>
                      </li>
                      <li>
                        <Link to={'/report/supplier/products/plans/time'}>مغایرت برنامه کاری تامین کنندگان</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      ویرایش فاکتور ها
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/edit/unmatch/invoice/remain`}>مغایرت موجودی و فاکتور ها</Link>
                      </li>
                      <li>
                        <Link to={`/report/edited/invoice`}>مشاهده ویرایش های انجام شده</Link>
                      </li>
                      <li>
                        <Link to={`/report/customer/edited/invoice`}>مشتریانی که فاکتورشان ویرایش شده</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link to={`/report/oil`}>سهمیه بنزین</Link>
                  </li>
                  <li>
                    <Link to={`/transferCost`}>هزینه جا به جایی محصول</Link>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      جایگاه
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/driverCartStation/report`}>جایگاه رسانندگان</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      مدیریت فرایندها
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/deliveryStatus/add`}>افزودن فرایند</Link>
                      </li>
                      <li>
                        <Link to={`/deliveryStatus/report`}>گزارش فرایندها </Link>
                      </li>

                      <li>
                        <Link to={`/deliveryStatus/my`}>فرایند های من </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>

                <a href="#">انبار</a>
                <ul className="subMenu">
                  <li>
                    <Link to={`/addPreRecord?id=${this.randomNumber()}`} target={'_blank'}>
                      افزودن پیش سند
                    </Link>
                  </li>

                  <li>
                    <Link to={`/PreRecord`}>پیش اسناد</Link>
                  </li>

                  <li>
                    <Link to={`/Record`}>اسناد</Link>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>

                <a href="#">گزارشات</a>
                <ul className="subMenu">
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      عمومی
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/report/forMali'}>دریافتی واحد مالی</Link>
                      </li>
                      <li>
                        <Link to={'/Providers'}>تامین کنندگان</Link>
                      </li>
                      <li>
                        <Link to={'/Products'}>محصولات</Link>
                      </li>

                      <li>
                        <Link to={'/editedAddress'}>آدرس های ویرایش شده</Link>
                      </li>

                      {/*<li>*/}
                      {/*<Link to={'/reportUser'}>*/}
                      {/*گزارش تراکنش کاربر</Link>*/}
                      {/*</li>*/}
                      {/*<li>*/}
                      {/*<Link to={'/reportUsers'}>*/}
                      {/*گزارش تراکنش کاربران</Link>*/}
                      {/*</li>*/}

                      <li>
                        <Link to={'/report/user/transaction'}>گزارش تراکنش های کاربر</Link>
                      </li>

                      <li>
                        <Link to={'/report/users/transaction'}>گزارش تراکنش های کاربران</Link>
                      </li>
                      <li>
                        <Link to={'/report/incompatible/deliveryPackAll'}>مغایرت کالا ها در سیستم</Link>
                      </li>
                      <li>
                        <Link to={'/Report/TerminalHistory'}>تاریخچه انتصاب ترمینال ها</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      سفارش تامین کنندگان
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/SupplierOrder'}>گزارش سفارش تامین کنندگان</Link>
                      </li>

                      <li>
                        <Link to={'/master/supplyOrder'}>سر جمع سفارش تامین کنندگان</Link>
                      </li>
                      <li>
                        <Link to={'/negative/supply-orders'}>گزارش اقلام کسر شده از سفارش تامین</Link>
                      </li>
                      <li>
                        <Link to={'/supplyOrder/incomplete'}>گزارش نقص وضعیت سفارش</Link>
                      </li>
                      <li>
                        <Link to={'/supplyOrder/orderStatus'}>وضعیت سفارش تامین کنندگان</Link>
                      </li>
                      <li>
                        <Link to={'/report/orderDispatch/incompatible'}>اسناد ثبت شده</Link>
                      </li>

                      <li>
                        <Link to={'/reportRemainProvider'}>گزارش کالای تامین کننده</Link>
                      </li>

                      <li>
                        <Link to={'/report/retail/supplied/percent'}>میزان دقت تامین کالا</Link>
                      </li>
                      <li>
                        <Link to={'/report/retail/supplied/notices'}>اطلاع رسانی تامین کالا</Link>
                      </li>

                      <li>
                        <Link to={'/report/jasper/product/driver'}>گزارش کالای راننده</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/cart/invoices'}>گزارش جمع آوری سفارشهای جایگاه</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/cart/products'}>گزارش چیدمان بر اساس فاکتور</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/cart/products-report'}>فرم چیدمان</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/cart/products-re-report'}>فرم چیدمان مجدد</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/cart/sorted-products'}>گزارش کالاهای چیده شده</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/cart/layout-grouping'}>گزارش گروه بندی چیدمان</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/order/provider'}>نقص برنامه کاری تامین کنندگان</Link>
                      </li>
                      <li>
                        <Link to={'/report/jasper/driver/providers'}>گزارش تامین کنندگان رساننده</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      توزیع
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/Invoice'}>فاکتور ها</Link>
                      </li>

                      <li>
                        <Link to={'/SubInvoice'}>ریز فاکتور ها</Link>
                      </li>
                      <li>
                        <Link to={'/report/driver/completeProductDriver'}>کالاهای تکمیل شده رانندگان</Link>
                      </li>

                      <li>
                        <Link to={'/report/driver/shortage'}>رساننده های آماده اعزام</Link>
                      </li>

                      <li>
                        <Link to={'/baskets'}>پارت تحویل</Link>
                      </li>

                      <li>
                        <Link to={`/report/parcel/label`}>چاپ لیبل سبد بر اساس فاکتور</Link>
                      </li>

                      <li>
                        <Link to={'/report/listShortageDriver'}>گزارش حداقل کسری رساننده</Link>
                      </li>

                      <li>
                        <Link to={'/orderComparision/baseOnOrder'}>برنامه پخش اقلام سفارش تامین کننده</Link>
                      </li>
                      <li>
                        <Link to={'/orderComparision/baseOnDispatch'}>برنامه تامین اقلام پارت تحویل</Link>
                      </li>

                      <li>
                        <Link to={'/subBaskets'}>ریز پارت تحویل</Link>
                      </li>

                      <li>
                        <Link to={'/dispatch'}>توزیع</Link>
                      </li>
                      <li>
                        <Link to={'/subDispatch'}>ریز توزیع</Link>
                      </li>

                      <li>
                        <Link to={'/allFactorsDrivers'}>فاکتور های رساننده ها</Link>
                      </li>

                      <li>
                        <Link to={'/productColumns'}>گزارش ستونی محصولات تامین کننده</Link>
                      </li>

                      <li>
                        <Link to={'/RemainReportDriver'}>مانده ی رساننده</Link>
                      </li>

                      <li>
                        <Link to={'/ReportPaid'}>پرداختی ها</Link>
                      </li>

                      <li>
                        <Link to={'/reportTransferCost'}>گزارش هزینه حمل</Link>
                      </li>
                      <li>
                        <Link to={'/transferCostByProvider'}>گزارش هزینه حمل بر مبنای تامین کننده</Link>
                      </li>

                      {/*<li>*/}
                      {/*<Link to={'/reportHistoryBought'}>*/}

                      {/*گزارش سابقه خرید مشتریان</Link>*/}
                      {/*</li>*/}

                      <li>
                        <Link to={'/inquiry'}>استعلام فاکتور</Link>
                      </li>

                      <li>
                        <Link to={'/driver-commission-report'}>گزارش پورسانت راننده</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      خرید و فروش
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/report/rfml'}>گزارش سابقه خرید مشتریان </Link>
                      </li>

                      <li>
                        <Link to={'/call-to-buy/master'}>گزارش درصد موفقیت تماس اپراتورها</Link>
                      </li>

                      <li>
                        <Link to={'/report/retail/purchase/byTime'}>گزارش پرفروش ترین ها</Link>
                      </li>

                      <li>
                        <Link to={'/report/retail/purchase/product'}>محصولات جدید</Link>
                      </li>

                      <li>
                        <Link to={'/report/retail/purchase/invoiceItem'}>میانگین کالای هر فاکتور</Link>
                      </li>

                      <li>
                        <Link to={'/report/purchase/deliveryPack'}>اشانتیون پارت تحویل</Link>
                      </li>

                      <li>
                        <Link to={'/report/purchase/customer'}>عدم خرید مشتریان</Link>
                      </li>

                      <li>
                        <Link to={'/report/purchase/provider'}>عدم فروش تامین کنندگان</Link>
                      </li>

                      <li>
                        <Link to={'/report/purchase/firstTime'}>مشتریان خرید اولی</Link>
                      </li>
                      <li>
                        <Link to={'/report/purchase/multiPack'}>مشتریان چند پارته</Link>
                      </li>
                      <li>
                        <Link to={'/report/purchase/firstDeliveryPack'}>اولین پارت تحویل مشتریان جدید</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      باشگاه مشتریان
                    </a>

                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/club/club`}>باشگاه مشتریان</Link>
                      </li>
                      <li>
                        <Link to={`/club/customer/reportCard`}>کارنامه مشتری</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      تحویل فاکتور ها
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/report/delivery/delivered`}>تحویل شده ها</Link>
                      </li>
                      <li>
                        <Link to={`/report/delivery/time`}>گزارش زمانی</Link>
                      </li>
                      <li>
                        <Link to={`/report/delivery/location`}>گزارش موقعیت ها</Link>
                      </li>
                      <li>
                        <Link to={`/report/delivery/notEdited`}>فاکتورهایی که موقعیت نداشته و ویرایش نشده</Link>
                      </li>
                      <li>
                        <Link to={`/report/delivery/NotDelivered`}>فاکتورهایی که در موقعیت موردنظر تحویل نشده</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      مالی
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/report/depot/productPrice/toCustomer'}>
                          گزارش قیمت کالاهای دپویی تحویل به مشتری
                        </Link>
                      </li>

                      <li>
                        <Link to={`/warehouse/products/price`}>گزارش قیمت کالاهای وارده به انبار</Link>
                      </li>

                      <li>
                        <Link to={`/warehouse/products/byMonth/price`}>
                          گزارش دوره ای قیمت کالای وارده به انبار
                        </Link>
                      </li>

                      <li>
                        <Link to={`/Remains?from=financial`}>موجودی</Link>
                      </li>
                      <li>
                        <Link to={`/Cardex?from=financial`}>کاردکس</Link>
                      </li>
                      <li>
                        <Link to={`/warehouseIO?from=financial`}>گردش انبار</Link>
                      </li>

                      <li>
                        <Link to={`/report/io/byProvider?from=financial`}>گردش انبار با تامین کننده</Link>
                      </li>

                      <li>
                        <Link to={`/report/io/byCustomer?from=financial`}>گردش انبار با مشتری</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      انبار
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/Remains?from=inventory`}>موجودی</Link>
                      </li>
                      <li>
                        <Link to={`/Cardex?from=inventory`}>کاردکس</Link>
                      </li>

                      <li>
                        <Link to={`/warehouseDepots/products/price/depot`}>
                          گزارش قیمت کالاهای وارده به انبار چیدمان از انبار دپو
                        </Link>
                      </li>

                      <li>
                        <Link to={`/productPrice/depot/periodic`}>
                          گزارش دوره‌ای قیمت کالاهای وارده به انبار چیدمان از انبار دپو
                        </Link>
                      </li>

                      <li>
                        <Link to={`/report/products/depot`}>لیست کالاهای رزرو دپو</Link>
                      </li>

                      <li>
                        <Link to={`/warehouse/current/difference`}>
                          گزازش لحظه ای موجودی اشتباه انبارهای چیدمان
                        </Link>
                      </li>

                      <li>
                        <Link to={`/warehouseIO?from=inventory`}>گردش انبار</Link>
                      </li>

                      <li>
                        <Link to={`/report/io/byProvider?from=inventory`}>گردش انبار با تامین کننده</Link>
                      </li>

                      <li>
                        <Link to={`/report/io/byCustomer?from=inventory`}>گردش انبار با مشتری</Link>
                      </li>

                      <li>
                        <Link to={'/unMatchCardex'}>مغایرت موجودی و کاردکس</Link>
                      </li>
                      <li>
                        <Link to={'/unMatchRemain'}>مغایرت موجودی و پارت تحویل</Link>
                      </li>

                      <li>
                        <Link to={'/reportWeight'}>گزارش وزن کشی</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>

                <a href="#">اطلاعات پایه</a>
                <ul className="subMenu">
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      عمومی
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/Cities'}>گزارش شهر ها</Link>
                      </li>
                      <li>
                        <Link to={`/Province`}>گزارش استان ها</Link>
                      </li>
                      <li>
                        <Link to={`/Cars`}>گزارش نوع اتومبیل ها</Link>
                      </li>
                      <li>
                        <Link to={`/Reson`}>گزارش دلایل</Link>
                      </li>

                      <li>
                        <Link to={`/Payment`}>گزارش نوع پرداخت</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      پرداخت
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/Base/payment/banks'}>بانک ها</Link>
                      </li>
                      <li>
                        <Link to={'/Base/payment/terminals'}>پایانه ها</Link>
                      </li>
                      <li>
                        <Link to={'/upload'}>بارگذاری فایل</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      امنیت
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/editPermission`}>دسترسی ها</Link>
                      </li>

                      <li>
                        <Link to={`/roles`}>نقش ها</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      جایگاه
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/cartStation/report`}>لیست جایگاه ها</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      کاربران
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/addUser`}>افزودن کاربر</Link>
                      </li>

                      <li>
                        <Link to={`/Operators`}>اپراتور ها</Link>
                      </li>

                      <li>
                        <Link to={`/Drivers`}>رساننده ها</Link>
                      </li>

                      <li>
                        <Link to={`/base/users/persina`}>کاربران پرسینا</Link>
                      </li>

                      <li>
                        <Link to={`/PersonReason`}>دلایل تغییر حالت کاربر</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link to={`/allCars`}>ماشین ها</Link>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      انبار
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/WareHouseList`}>انبار ها</Link>
                      </li>
                      <li>
                        <Link to={`/listDocType`}>نوع اسناد</Link>
                      </li>
                      <li>
                        <Link to={`/AddWarehouse`}>افزودن انبار</Link>
                      </li>
                      <li>
                        <Link to={`/addDocType`}>افزودن نوع سند </Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      وضعیت سفارشات
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/base/orderStatus/reportOrderStatus'}>وضعیت</Link>
                      </li>

                      <li>
                        <Link to={'/base/orderStatus/reportLocationStatus'}>محل تحویل</Link>
                      </li>

                      <li>
                        <Link to={'/base/orderStatus/provider/plans'}>برنامه تامین کننده</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      مدیریت فرایندها
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/base/deliveryStatus/reportDeliveryStatus'}>وضعیت</Link>
                      </li>

                      <li>
                        <Link to={'/base/deliveryStatus/reportLocationStatus'}>لیست آیتم انتخابی</Link>
                      </li>
                      <li>
                        <Link to={'/base/deliveryStatus/processCategories'}>دسته فرایند </Link>
                      </li>
                      <li>
                        <Link to={'/base/deliveryStatus/familyStatusChanges'}>خانواده فرایند </Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      ارتباط با مشتری
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/reportMedia'}>رسانه های تماس</Link>
                      </li>

                      <li>
                        <Link to={'/reportCategory'}>خانواده تماس</Link>
                      </li>

                      <li>
                        <Link to={'/reportSubject'}>موضوع تماس</Link>
                      </li>

                      <li>
                        <Link to={'/reportDefinition'}>جزییات تماس</Link>
                      </li>

                      <li>
                        <Link to={'/reportPriority'}>اولویت ها</Link>
                      </li>

                      <li>
                        <Link to={'/reportStatus'}>وضعیت ها</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      پیام رسان
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/base/messanger/reportTemplate'}>الگو های پیام</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>

                    <a href="#" className="subLink">
                      مدیریت فعالیت ها
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={'/base/report/tms/department'}>دپارتمان ها</Link>
                      </li>

                      <li>
                        <Link to={'/base/report/tms/sections'}>بخش ها</Link>
                      </li>

                      <li>
                        <Link to={'/base/report/tms/taskType'}>وظایف</Link>
                      </li>

                      <li>
                        <Link to={'/base/report/tms/taskUnit'}>واحد های وظیفه</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>

                <a href="#">ارتباط با مشتری</a>
                <ul className="subMenu">
                  <li>
                    <Link to={`/CRM/sendSms`}>ارسال sms</Link>
                  </li>
                  <li>
                    <Link to={`/CRM/add`}>افزودن دیدگاه مشتری</Link>
                  </li>

                  <li>
                    <Link to={`/CRM/list`}>گزارش دیدگاه مشتریان</Link>
                  </li>

                  <li>
                    <Link to={`/CRM/sms/hr/report`}>گزارش sms های منابع انسانی</Link>
                  </li>
                  <li>
                    <Link to={`/CRM/sms/crm/report`}>گزارش sms های ارتباط با مشتریان</Link>
                  </li>
                </ul>
              </li>

              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>

                <a href="#">پیام رسان</a>
                <ul className="subMenu">
                  <li>
                    <Link to={`/messanger/newMessage`}>ارسال پیام جدید</Link>
                  </li>

                  <li>
                    <Link to={`/messanger/report/received`}>پیام های دریافت شده</Link>
                  </li>

                  <li>
                    <Link to={`/messanger/report/send`}>پیام های ارسال شده</Link>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>
                <a href="#">مدیریت فعالیت ها</a>

                <ul className="subMenu">
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      گزارشات
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/tms/report/activity/functionality`}>گزارش عملکرد</Link>
                      </li>
                      <li>
                        <Link to={`/tms/task/percent/functionality`}>نسبت عملکرد</Link>
                      </li>
                      <li>
                        <Link to={`/tms/task/jalali/functionality`}>نسبت عملکرد دوره ای</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      کاربر
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/tms/task/create`}>ثبت فعالیت</Link>
                      </li>
                      <li>
                        <Link to={`/tms/task/report`}>فعالیت ها ثبت شده</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <span className="caret">
                      <i className="fas fa-caret-down" />
                    </span>
                    <a href="#" className="subLink">
                      مدیر
                    </a>
                    <ul className="SubSubMenu">
                      <li>
                        <Link to={`/tms/manageTask/create`}>ثبت فعالیت</Link>
                      </li>
                      <li>
                        <Link to={`/tms/manageTask/report`}>تایید فعالیت ها</Link>
                      </li>
                      <li>
                        <Link to={`/tms/manageTask/history`}>تاریخچه فعالیت ها</Link>
                      </li>
                      <li>
                        <Link to={`/tms/report/duplicated`}>فعالیت های تکراری</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <i className="fas fa-caret-down" />
                </span>
                <a href="#">تنظیمات</a>
                <ul className="subMenu">
                  <li>
                    <Link to={`/variable`}>متغیر های سیستمی</Link>
                  </li>
                  <li>
                    <Link to={`/version`}>نسخه های اپلیکیشن</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </React.Fragment>
      </div>
    )
  }
}

export default withRouter(AdminMenu)
